export const GOOGLE_MAPS_API_KEY = 'AIzaSyCzlKQA60nFU2r-fhBOmU0rudHq72e3OUw';
export const LAUNCH_DARKLY_KEY = '5d2783cae49136076604bb2a';
export const INTEL_URL = 'https://bi.uniteus.io';
export const INTERCOM_APP_ID = '5bk7r0hl';
export const IP_INFO_KEY = '83a51b5f488d26';
export const PAYMENTS_URL = 'https://smso.uniteus.io';
export const ROUTE_BASEPATH = '/';
export const SHARES_URL = 'https://groups.uniteus.io';
export const TABLEAU_BASE_URL = 'https://tableau.uniteus.io';
export const TABLEAU_DASHBOARD_URL = 'InsightsCenter/InsightsCenter?';
export const UNITEUS_GEOGRAPHY_URL = 'https://geo.uniteus.io/v1';
export const UNITEUS_SUPPORT_URL = 'https://support.uniteus.io/';
export const WS_URL = 'wss://ws.uniteus.io/ws';

export const AUTH_URL = 'https://app.auth.uniteus.io';
export const CLIENT_ID = 'wiuehod3278u2dhowh8';

export const CORE_BASE_URL = 'https://core.uniteus.io';
export const CORE_LEGACY_API_URL = `${CORE_BASE_URL}/legacy`;
export const CORE_API = `${CORE_BASE_URL}/v1`;
export const SEARCH_API = 'https://search-ext.uniteus.io/v1';

export const TRACKING_URL = 'https://t.uniteus.io';
export const CONSENT_APP_URL = 'https://consent.uniteus.io';
export const CONSENT_DOWNLOAD_URL = 'https://s3.amazonaws.com/documents.uniteus.io/Unite-Us-Consent.pdf';

export const MESSAGING_SERVICE_URL = 'https://message-service-ext.uniteus.io';

export const DATADOG_APPLICATION_ID = 'd8c640d6-eb1b-4527-8553-d7380ffcc36f';
export const DATADOG_CLIENT_TOKEN = 'pubafab4be76592cdbb2cbf56aebb441827';
export const DATADOG_ENVIRONMENT = 'production';
export const DATADOG_PROXY_URL = 'https://datadog.uniteus.io';
export const DATADOG_LOGS_ENABLED = true;
export const DATADOG_CONSOLE_LOG_ENABLED = false;

export const PRD_API_URL = 'https://prd-api.uniteus.io';
export const PRD_FE_DOMAIN = 'resources.uniteus.io';

export const SCREENING_BASE_URL = 'https://screenings-ingestion.uniteus.io';
export const ELIGIBILITY_ASSESSMENT_TEMPLATE = '';
